/* eslint-disable no-unused-vars */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import Store from './Storage/Store'
import { Provider } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.css'
import AOS from 'aos'
import 'aos/dist/aos.css'

import { ProtectedRoutes } from './Components'
import { AuthProvider } from './Components/AuthProvider/AuthProvider'
import { ApplicantProfile, Applicants, AutomatedInterview, Login, Settings } from './Pages/Frontend/Interfaces/Index'
// import AutomatedApplicantProfile from './Pages/Frontend/Components/AutomateReview/ApplicantProfile/ApplicantProfile'
import AutomatedReview from './Pages/Frontend/Components/AutomateReview/Dashboard/Dashboard'
import AutomatedApplicantProfile from './Pages/Frontend/Components/AutomateReview/ApplicantProfile/ApplicantProfile'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
const dashroute = localStorage.getItem('__userRole')
const isOfficer = dashroute === 'pscreen_officer'
root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login></Login>}></Route>
            <Route path="/" element={<Login></Login>}></Route>
           <Route
              path="/dashboard"
              element={
                <ProtectedRoutes>
                  <AutomatedInterview />
                </ProtectedRoutes>
              }
            />
            <Route path="/automatedapplicant/:nin" element={<ProtectedRoutes> <AutomatedApplicantProfile /> </ProtectedRoutes>} />
            <Route path="/settings" element={<ProtectedRoutes> <Settings /> </ProtectedRoutes>} />
            <Route path="/applicant/:nin" element={<ProtectedRoutes> <ApplicantProfile /> </ProtectedRoutes>} />
            <Route path="/applicants" element={<ProtectedRoutes> <Applicants /> </ProtectedRoutes>} />

          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
AOS.init()
